"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const srtParser_1 = require("./srtParser");
const vttParser_1 = require("./vttParser");
const parse = (raw) => {
    return raw.startsWith('WEBVTT') ? vttParser_1.vttParser(raw) : srtParser_1.srtParser(raw);
};
exports.parse = parse;
